import { render, staticRenderFns } from "./ClientSorting.vue?vue&type=template&id=158447e3&scoped=true&"
import script from "./ClientSorting.vue?vue&type=script&lang=js&"
export * from "./ClientSorting.vue?vue&type=script&lang=js&"
import style0 from "./ClientSorting.vue?vue&type=style&index=0&media=print&lang=scss&"
import style1 from "./ClientSorting.vue?vue&type=style&index=1&id=158447e3&scoped=true&lang=scss&"
import style2 from "./ClientSorting.vue?vue&type=style&index=2&id=158447e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158447e3",
  null
  
)

export default component.exports